<template>
  <el-dialog
    :title="$t('personal::contract::addCard')"
    :visible.sync="visible"
    width="480px"
    :append-to-body="true"
    :destroy-on-close="true"
    @closed="closed"
  >
    <div>
      <el-row :gutter="24" v-if="visible">
        <el-col :span="24" class="">
          <div class="card-title">
            <span>*</span>
            {{ $t('personal::contract::卡号') }}
          </div>
          <div id="card-number" class="input"></div>
          <div class="error-wrap" id="cardNumber-errors"></div>
        </el-col>
        <el-col :span="12">
          <div class="card-title">
            <span>*</span>
            {{ $t('personal::contract::到期日期') }}
          </div>
          <div id="card-date" class="input"></div>
          <div class="error-wrap" id="cardDate-errors"></div>
        </el-col>
        <el-col :span="12">
          <div class="card-title">
            <span>*</span>
            {{ $t('personal::contract::安全码') }}
          </div>
          <div id="card-cvc" class="input"></div>
          <div class="error-wrap" id="cardCvc-errors"></div>
        </el-col>
      </el-row>
      <div class="pay-tips">
        <el-checkbox v-model="isCheck">{{ $t('personal::contract::accept-tips') }}</el-checkbox>
        <a @click="toPdf">《{{ $t('personal::contract::服务协议') }}》</a>
        <p class="pay-tips__desc">
          {{ $t('personal::contract::pay-tips') }}
        </p>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="visible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click.stop="submit" :loading="loading">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import { bindCompelete, getBindContract, bindCardFail } from '@/server/personal/contract'
export default {
  data() {
    return {
      visible: false,
      cardNumber: null,
      cardDate: null,
      cardCvc: null,
      isCheck: false,
      loading: false,
    }
  },
  props: {
    value: {},
  },
  methods: {
    toPdf() {
      window.open('/xieyi.pdf', '_blank')
    },
    init() {
      this.$nextTick(() => {
        console.log(process.env.VUE_APP_ENV)
        this.stripe = Stripe(
          ['dev', 'test'].includes(process.env.VUE_APP_ENV)
            ? 'pk_test_51IuWg9KnDWrNQiNS8LVTrmRWEBLRPhCyDWCGKiEvnTMbaFlPvTt0su48IAbj71801S0P42foXRo0Bqg7j97g2P6D00rPsMWsvW'
            : // ? 'pk_live_51HjEn8L5IRjRW9FDWXJgDAjtf9rsfUYMy1T5xiu1yEZPYroyF0HDIjwE7WT9cHLZk72E0XvwORjacduPqf07dnOF00siAs0T7h'
            process.env.VUE_APP_ENV === 'uat'
            ? // ? 'pk_live_51IuWg9KnDWrNQiNSQQnG6kRO2SM8Gi7AONgPzRMQw93TOBbrnifgjL0YQd4driZcYr4KG64cqlSlNMrFZ2iNkwsQ00ezywhBzd'
              'pk_live_51HjEn8L5IRjRW9FDWXJgDAjtf9rsfUYMy1T5xiu1yEZPYroyF0HDIjwE7WT9cHLZk72E0XvwORjacduPqf07dnOF00siAs0T7h'
            : 'pk_live_51JeIKQHIljMoNvzLuOA7KAYvYNaPA5DC8SFahpsFqzWflzzGQKRhXEEI6crWYSA763YnH1S2DLP6iyWMKE8pNy3N00ZZEzSz3U'
        )
        let elements = this.stripe.elements({ locale: Cookies.get('language') == 'en' ? 'en' : 'zh' })
        var style = {
          iconStyle: 'solid',
          base: {
            color: '#010517',
            fontSize: '14px',
            '::placeholder': {
              color: '#999999',
            },
          },
          invalid: {
            color: '#ff0022',
            iconColor: '#fa755a',
          },
        }
        this.cardNumber = elements.create('cardNumber', {
          style: style,
          placeholder: this.$t('personal::open-contract::请输入卡号'),
        })
        this.cardNumber.mount('#card-number')
        this.cardDate = elements.create('cardExpiry', {
          style: style,
          placeholder: this.$t('personal::open-contract::有效期(MM/YY)'),
        })
        this.cardDate.mount('#card-date')
        this.cardCvc = elements.create('cardCvc', {
          style: style,
          placeholder: this.$t('personal::open-contract::卡安全码'),
        })
        this.cardCvc.mount('#card-cvc')
        const cards = ['cardNumber', 'cardDate', 'cardCvc']
        cards.forEach(item => {
          this[item].on('change', event => {
            let displayError = document.getElementById(`${item}-errors`)
            if (event.error) {
              displayError.textContent = event.error.message
            } else {
              displayError.textContent = ''
            }
          })
        })
      })
    },
    async submit() {
      if (!this.isCheck) return this.$message.warning(this.$t('personal::contract::agreement-tips'))
      this.loading = true
      const { data } = await getBindContract()
      if (data.code === this.$code) {
        const clientSecret = data.data.clientSecret // 绑卡密钥
        // 订阅
        await this.stripe
          .confirmCardSetup(clientSecret, {
            payment_method: {
              card: this.cardNumber,
              billing_details: {
                name: this.$store.state.user.userName,
              },
            },
          })
          .then(async result => {
            console.log(result)
            if (result.error) {
              // this.$message.warning(this.$t('personal::contract::pay_error_tips'))
              this.$message.warning(result.error.message)
              await bindCardFail({
                cardBrand:
                  (result.error.payment_method &&
                    result.error.payment_method.card &&
                    result.error.payment_method.card.brand) ||
                  '',
                cardNum:
                  (result.error.payment_method &&
                    result.error.payment_method.card &&
                    result.error.payment_method.card.last4) ||
                  '',
                failReason: result.error.message,
                platform: 1,
              })
            } else {
              const status = await this.checkCard()
              if (status) {
                this.$message.success(this.$t('personal::contract::绑卡成功'))
                this.$emit('success')
                this.visible = false
              }
            }
          })
      }
      this.loading = false
    },
    async checkCard() {
      const { data } = await bindCompelete()
      if (data.code === this.$code) {
        return !!data.data
      }
    },
    closed() {
      this.isCheck = false
    },
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    visible(val) {
      this.$emit('input', val)
      if (val) {
        this.init()
      }
    },
    value(val) {
      this.visible = val
    },
  },
}
</script>

<style scoped lang="scss">
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #010517;
}
.pay-tips {
  font-size: 14px;
  text-align: left;
  margin-top: 16px;
  &__desc {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    margin-top: 11px;
    line-height: 18px;
  }
}
.card-title {
  margin: 0 0 16px;
  span {
    color: #ff0022;
    margin-right: 5px;
  }
}
.error-wrap {
  color: #ff0022;
  margin-bottom: 12px;
}
.StripeElement {
  box-sizing: border-box;
  height: 45px;
  padding: 12px 14px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  background-color: white;
}
.StripeElement--focus {
  box-shadow: 0 1px 5px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #ff0022;
}
.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
